<template>
  <Loader v-show="!isClient" :isParent="true" />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
<script setup>
import "./assets/styles/index.scss";
import Loader from "~/components/Loader.vue";
import { useMiraStore } from "./store/mira";
import { useViewerStore } from "./store/viewer";
//variables
const route = useRoute();
const isPortrait = ref(null);
const isClient = ref(false);
const miraStore = useMiraStore();
const { $busSocket } = useNuxtApp();
const viewerStore = useViewerStore();
const headers = useRequestHeaders(["referer"]);
//provide
provide("isPortrait", isPortrait);

//methods
const updateOrientation = () => {
  if (miraStore.inputInFocus) return;
  isPortrait.value = window.innerHeight > window.innerWidth;
  viewerStore.isPortrait = isPortrait.value;
};

function checkServerOrientation() {
  if (process.client) return;
  const headers = useRequestHeaders();
  const userAgent = headers["user-agent"] || "";
  const isMobile =
    /Mobile|Android|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      userAgent
    );
  isPortrait.value = isMobile ? true : false;
  viewerStore.isPortrait = isPortrait.value;
}

// set referer cookie
if (process.server) {
  checkServerOrientation();
  const referer = headers.referer || "";
  const prevReferer = useCookie("visitor_referer");
  if (
    referer &&
    (!prevReferer.value || prevReferer.value.includes("travvir.com"))
  ) {
    const refererCookie = useCookie("visitor_referer", {
      maxAge: 15 * 60,
      path: "/",
    });
    refererCookie.value = referer;
  }
}

if (process.client) {
  updateOrientation();
  let busSocket = $busSocket.open();
  provide("busSocket", busSocket);
}

onMounted(() => {
  isClient.value = true;
  window.addEventListener("resize", updateOrientation);
  window.addEventListener("orientationchange", () => {
    miraStore.inputInFocus = false;
    updateOrientation();
  });
});
onUnmounted(() => {
  window.removeEventListener("resize", updateOrientation);
  window.removeEventListener("orientationchange", updateOrientation);
});
</script>

<style lang="scss" scoped></style>
